var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M6.00839 4.47064C5.88897 4.47064 5.79217 4.56744 5.79217 4.68685V19.8217H18.3583V9.43912C18.3583 9.32661 18.3145 9.21854 18.2361 9.13783L13.8304 4.60178C13.749 4.51795 13.6371 4.47064 13.5202 4.47064H6.00839ZM4.49487 4.68685C4.49487 3.85096 5.1725 3.17334 6.00839 3.17334H13.5202C13.9877 3.17334 14.4353 3.36257 14.761 3.69793L19.1667 8.23398C19.4802 8.5568 19.6556 8.9891 19.6556 9.43912V20.4704C19.6556 20.8286 19.3652 21.119 19.0069 21.119H5.14352C4.78528 21.119 4.49487 20.8286 4.49487 20.4704V4.68685Z",
  fill: "white"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M12.6775 9.59943V3.82202H13.9748V9.167H19.007V10.4643H13.5424C13.0647 10.4643 12.6775 10.0771 12.6775 9.59943Z",
  fill: "white"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M14.625 12.0431L11.9962 14.6841L9.36732 12.0431L8.44788 12.9583L11.5364 16.0612C11.6582 16.1834 11.8236 16.2522 11.9962 16.2522C12.1687 16.2522 12.3341 16.1834 12.4559 16.0612L15.5444 12.9583L14.625 12.0431Z",
  fill: "white"
});

function SvgDownloadCv(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadCv);
export default __webpack_public_path__ + "static/media/DownloadCV.f1373037.svg";
export { ForwardRef as ReactComponent };